import { render, staticRenderFns } from "./IconStockDetail.vue?vue&type=template&id=42b96a55&"
import script from "./IconStockDetail.vue?vue&type=script&lang=js&"
export * from "./IconStockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports